import React from "react";

interface HomeProps {
  width?: number;
  height?: number;
  fillColor?: string;
}

const Home: React.FC<HomeProps> = ({
  width = 20,
  height = 16,
  fillColor,
}) => {
  return (
    <svg
    width={width}
    height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_3329_63231)">
        <path
          d="M14.7275 16H11.4485C10.7467 16 10.176 15.392 10.176 14.6445V9.42857C10.176 9.2739 10.057 9.14715 9.91177 9.14715H6.09024C5.94505 9.14715 5.82607 9.2739 5.82607 9.42857V14.6445C5.82607 15.392 5.25536 16 4.55357 16H1.2725C0.570708 16 0 15.392 0 14.6445V7.59398C0 6.88507 0.290396 6.21482 0.798588 5.75725L6.53592 0.573577C7.38291 -0.191192 8.61306 -0.191192 9.46005 0.573577L15.2014 5.75725C15.7096 6.21482 16 6.88507 16 7.59398V14.6423C16 15.3899 15.4293 15.9979 14.7275 15.9979V16ZM6.09024 8.07089H9.91177C10.6136 8.07089 11.1843 8.67884 11.1843 9.42642V14.6423C11.1843 14.797 11.3033 14.9237 11.4485 14.9237H14.7275C14.8727 14.9237 14.9917 14.797 14.9917 14.6423V7.59398C14.9917 7.20086 14.8304 6.82922 14.548 6.57572L8.80867 1.39205C8.3388 0.968851 7.65717 0.968851 7.1873 1.39205L1.44996 6.57572C1.16763 6.82922 1.00832 7.20086 1.00832 7.59398V14.6445C1.00832 14.7991 1.1273 14.9259 1.2725 14.9259H4.55155C4.69675 14.9259 4.81573 14.7991 4.81573 14.6445V9.42857C4.81573 8.68099 5.38644 8.07304 6.08823 8.07304L6.09024 8.07089Z"
          fill={fillColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_3329_63231">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Home;

